import templates from '../../api/templates'
import { Message } from 'element-ui'
import lodash from 'lodash';

const state = {
  signatures: [], // 所有签名集合
  lastSignatureId: null, // 记录当前最后一条签名的id
  isEdit: false, // false[创建模板]/true[编辑模板]
  id: null, // 模板编号，编辑时用到
  title: '', // 短信标题
  content: '', // 短信内容
  report_type: 'vip', // 签名通道：general[普通]/vip[免审]
  type: 'industry', // 短信类型：industry[行业]/marketing[营销]
  content_type: 'standard',
  temp_sign: '', // 模板签名
  sign_location: 'top', // 签名位置
  global: 'intl'
};

const actions = {
  // 获取签名列表
  async getSignatures({ commit }, payload) {
    const params = lodash.cloneDeep(payload);
    delete params.init;
    const response = await templates.getSignatures(params);
    if (response.status === 200) {
      const { data } = response;
      commit({
        type: 'UPDATE_SIGNATURES',
        signatures: data.signatures,
        init: payload.init
      });
      if (data.signatures.length) {
        commit({
          type: 'UPDATE_SIGN',
          value: data.signatures[0].name
        });
      }
    }
  },
  // 添加一个签名
  async addSignature({ dispatch, commit }, action) {
    const { name } = action;
    const response = await templates.addSignature({ name });
    if (response.status === 201) {
      const { data } = response;
      Message.success('签名添加成功');
      dispatch('getSignatures', { limit: 500, init: true });
      commit('UPDATE_SIGN', {
        value: data.name
      });
    }
  },
  // 删除一个签名
  async delSignature({ dispatch, commit, state }, action) {
    const { id, name } = action.signInfo;
    const response = await templates.delSignature(id);
    if (response.status === 204) {
      Message.success('签名删除成功');
      commit({
        type: 'DELETE_SIGNATURE',
        id
      });
      if (state.temp_sign === name) {
        commit({
          type: 'UPDATE_SIGN',
          value: ''
        });
      }
    }
  },
  // 创建模板
  async createTemplate({ dispatch, commit }, payload) {
    const response = await templates.createTemplate(payload);
    if (response.status === 201) {
      return Promise.resolve('success');
    }
    return Promise.resolve('failure');
  },
  // 编辑模板
  async editTemplate({ dispatch, commit }, payload) {
    const response = await templates.editTemplate(payload);
    if (response.status === 200) {
      return Promise.resolve('success');
    }
    return Promise.resolve('failure');
  },
  // 获取模板信息
  async getTemplateInfo({ commit }, payload) {
    const response = await templates.getTemplateInfo(payload.id);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_TEMPLATE_INFO', { ...data, isEdit: true });
    } else {
      payload.router.push('/templates');
    }
  },
  // 创建模板
  async createMmsTemplate({ dispatch, commit }, payload) {
    const response = await templates.createMmsTemplate(payload);
    if (response.status === 200) {
      return Promise.resolve('success');
    }
    return Promise.resolve('failure');
  }
};

const mutations = {
  'INIT_TEMPLATE': (state) => {
    state.id = null;
    state.isEdit = false;
    state.type = 'industry';
    state.content_type = 'standard';
    state.title = '';
    state.content = '';
    state.temp_sign = '';
    state.report_type = 'vip';
    state.sign_location = 'top';
  },
  'INIT_REPORT_TYPE': (state, payload) => {
    state.report_type = 'vip';
  },
  'UPDATE_SIGNATURES': (state, payload) => {
    const last = (lodash.cloneDeep(payload.signatures)).pop();
    state.lastSignatureId = last ? last.id : null;
    if (payload.init) {
      state.signatures = payload.signatures;
    } else {
      state.signatures = (state.signatures).concat(payload.signatures);
    }
    // state = { ...state, signatures }; 这样行不通
  },
  'DELETE_SIGNATURE': (state, payload) => {
    const newSignatures = state.signatures.filter(item => {
      return item.id !== payload.id;
    });
    state.signatures = newSignatures;
  },
  'UPDATE_REPORT_TYPE': (state, payload) => {
    state.report_type = payload.value;
  },
  'UPDATE_TYPE': (state, payload) => {
    state.type = payload.value;
  },
  'UPDATE_CONTENT_TYPE': (state, payload) => {
    state.content_type = payload.value;
  },
  'UPDATE_TITLE': (state, payload) => {
    state.title = payload.value;
  },
  'UPDATE_CONTENT': (state, payload) => {
    state.content = payload.value;
  },
  'UPDATE_SIGN': (state, payload) => {
    state.temp_sign = payload.value;
  },
  'UPDATE_SIGN_LOCATION': (state, payload) => {
    state.sign_location = payload.value;
  },
  'UPDATE_GLOBAL': (state, payload) => {
    state.global = payload.value;
  },
  'UPDATE_TEMPLATE_INFO': (state, payload) => {
    const global = !(payload.type === 'industry' || payload.type === 'marketing')
    state.isEdit = payload.isEdit;
    state.id = payload.id;
    state.title = payload.title;
    state.content = payload.content;
    state.report_type = payload.report_type;
    state.type = !global ? payload.type : 'global';
    state.content_type = payload.content_type;
    state.global = global ? payload.type : '';
    state.temp_sign = payload.temp_sign;
    state.sign_location = payload.sign_location;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/createTemplate.js